"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
  margin: 5px;
  padding: 5px;
`;
